module.exports = __webpack_public_path__ + "img/4-2.2cb51f37.svg";